import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetAllClubsReservationPrivileges() {

    var url = "/reservation/all_clubs_with_reservation_app_privileges/";

    return FetchGetDataWithAuthNEW(url);
}

